import React, { useEffect } from 'react'
import SectionA from './Comp/SectionA/SectionA'
import Hero from './Comp/Hero/Hero'
import Faq from './Comp/Faq/Faq'
import { useLocation, useNavigate } from 'react-router-dom';
import SEO from '../../../seo/SEO';
import { SITE_URL } from '../../../seo/config';

export default function HowItWorks() {
    const navigateTo = useNavigate();

    const scrollToElement = (elementId) => {
        const targetElement = document.getElementById(elementId);

        if (targetElement) {
            const offset = 0;
            const targetPosition = targetElement.offsetTop + offset;

            window.scroll({
                top: targetPosition,
                behavior: "smooth",
            });
        }
    };
    const location = useLocation();

    useEffect(() => {
        const scrollInfo = location?.state?.scrollTo;
        if (scrollInfo) {
            setTimeout(() => {
                scrollToElement(scrollInfo.id, scrollInfo.offset);

                navigateTo(location.pathname, { replace: true, state: {} });
            }, 100);
        }
    }, [location.state]);

    // For SEO only
    const organization = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Fuel Clubs",
        "url": SITE_URL,
        "logo": `${SITE_URL}/logo.png`
    };

    const service = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "On-demand fuel delivery",
        "provider": { "@type": "Organization", "name": "Fuel Clubs" },
        "areaServed": { "@type": "City", "name": "Las Vegas" }
    };

    const howItWorksPage = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "How FuelClubs Works",
        "url": `${SITE_URL}/how-it-works`,
        "description":
            "Learn how FuelClubs on-demand fuel delivery works—from scheduling a fill-up to refueling your vehicle, fleet, or equipment at home, work, or the job site."
    };

    return (
        <>
            <SEO
                title="How FuelClubs Works | On-Demand Fuel Delivery Made Simple"
                description="Discover how FuelClubs on-demand fuel delivery works in Las Vegas and Henderson—from booking a fill-up to safe, contactless refueling at your location."
                keywords={[
                    'how FuelClubs works',
                    'fuel delivery process',
                    'mobile gas delivery Las Vegas',
                    'on-demand fuel how it works',
                    'FuelClubs membership faq'
                ]}
                robots="index, follow"
                canonical="/how-it-works"
                image="/logo.png"
                type="website"
                structuredData={[organization, service, howItWorksPage]}
            />

            <SectionA />
            <Hero />
            <Faq />
        </>
    )
}
